import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDetectLanguage } from "../helpers/language-detector";
import NotFound from "./not-found";
import {usePageTitle} from "../helpers/page-title";
import Social from "../includes/social";

export default function CustomPage() {
    const { t, ready } = useTranslation();
    const lang = useDetectLanguage();

    const { pathname } = useLocation();
    const slug = pathname.replace(/^\/|\/$/g, ""); // "church/history"

    const [error, setError] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!ready || !lang || !slug) return;

        const controller = new AbortController();

        setError(false);
        setLoading(true);
        setPageData(null); // IMPORTANT: prevents render crash / stale data

        fetch(`/api/${lang}/page/${slug}`, { signal: controller.signal })
            .then((res) => {
                if (res.status === 404) {
                    throw new Error("NOT_FOUND");
                }
                if (!res.ok) {
                    throw new Error(`Failed to fetch page: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                setPageData(data);
            })
            .catch((err) => {
                if (err.name === "AbortError") return;
                console.error(err);
                setError(true);
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [ready, lang, slug]);

    usePageTitle(
        pageData?.title
            ? `${pageData.title} | ${t('title.gaocna')}`
            : t('title.gaocna')
    );

    if (error) return <NotFound />;
    if (loading || !pageData) return null; // or return <div>Loading...</div>

    // ALSO SAFE: in case API returns unexpected shape
    return (
        <>
            <Social />
            <main className="container" role="custom_page">
                <div
                    className="page-content"
                    dangerouslySetInnerHTML={{ __html: pageData?.content ?? "" }}
                />
            </main>
        </>
    )
}
